   
import React, {useEffect} from 'react';



import {connect} from 'react-redux'
import { addToCart, reduceQuantity } from './actions/index.js';



// import {products} from './ProductList'
import { useDispatch, useSelector } from 'react-redux';

function Home(props){
    // const dispatch = useDispatch();
    // const products = useSelector(state => state.ListOfProduct)

    const products = props.data.reducer.ListOfProduct
    // useEffect(() => {
    //     console.log("sdsd" ,props.data.reducer.ListOfProduct)
    // })
    

    const AddToBasket = (product) => {
        // const obj = {
        //     name: product.productName,
        //     price: product.price,
        //     id: product.id,
        //     quantity: 1
        // }
        // addToCart(dispatch, obj)
    }


    return (
        <div className='flex-row wrap' id='itemList'>

            
            {Object.keys(products).map(i => (
                <div id={"item" +  products[i].id}>
                    <img 
                        src={products[i].src}
                        id={"img" +  products[i].id} 
                        alt={"img" +  products[i].id}
                    />
                    
                    <p id={"name" + products[i].id}>
                        {products[i].productName}
                    </p>

                    <label id={"stockDetail" +  products[i].id}>
                        {products[i].quantity === 0 ? "Out of Stock" : "In Stock" }
                    </label>

                    <p id={"price" +  products[i].id}>
                        {products[i].price}
                    </p>

                    {products[i].quantity === 0 ?
                        <button id={"button"  +  products[i].id} disabled onClick={() => {props.addToCartHandler(products[i]); props.reduceQuantityHandler(products[i])}} >
                            Add To Cart
                        </button>
                    :

                        <button id={"button"  +  products[i].id} onClick={() => {props.addToCartHandler(products[i]); props.reduceQuantityHandler(products[i])}} >
                            Add To Cart
                        </button>
                    }

                </div>
            ))}     
        </div>
    )
}

const mapStateToProps=state=>({
    data:state
})
const mapDispatchToProps=dispatch=>({
    addToCartHandler:data=>dispatch(addToCart(data)),
    reduceQuantityHandler:data=>dispatch(reduceQuantity(data))

})

export default connect(mapStateToProps,mapDispatchToProps)(Home)
